
export default {
  name: "Footer",
  data(): {
    links: Array<{ href: string; logo: string, name: string }>;
  } {
    return {
      links: [
        { href: "https://www.linkedin.com/in/jcrq/",  logo: 'bi-linkedin', name: "LinkedIn" },
        { href: "https://twitter.com/dev_evening",  logo: 'bi-twitter', name: "Twitter" },
        { href: "https://github.com/Eve-ning/",  logo: 'bi-github', name: "GitHub" },
        { href: "https://www.pixiv.net/en/users/9885588", logo: 'bi-brush', name: "pixiv" },
      ],
    };
  },
};
